module.exports = __webpack_public_path__ + "img/location.916f97ed.png";